import { useCallback } from 'react';
import { useAppSelector } from 'common/hooks/state';
import { parseObjectPropertiesToCamelCase } from 'common/utils/helpers';
import { mixpanelCustomEvent, MixpanelEventName, Dict } from 'common/utils/mixpanel/eventTriggers';
import { selectGuestToken } from 'features/GuestSession/guestSessionSlice';
import { ShepherdTrigger } from './types';

// trackingId derivation copied from useOnboardingTracking.ts (same selector/source):
// prefer the authenticated user's id, falling back to the guest session token.
export const useShepherdTracking = () => {
  const userStore = useAppSelector((state: any) => state.auth.user);
  const userProfileData = parseObjectPropertiesToCamelCase(userStore?.user || userStore);
  const guestToken = useAppSelector(selectGuestToken);
  const trackingId = userProfileData?.id?.toString() || guestToken || null;

  const trackEvent = useCallback((eventName: MixpanelEventName, mixpanelProps: Dict = {}) => {
    if (!trackingId) return;
    mixpanelCustomEvent({ mixpanelProps, id: trackingId, eventName });
  }, [trackingId]);

  return {
    trackStarted: useCallback((trigger: ShepherdTrigger) => {
      trackEvent(MixpanelEventName.shepherdStarted, { trigger });
      if (trigger === 'replay') trackEvent(MixpanelEventName.shepherdReplayed);
    }, [trackEvent]),
    trackStepViewed: useCallback((stepId: string, index: number) => trackEvent(MixpanelEventName.shepherdStepViewed, { step_id: stepId, index }), [trackEvent]),
    trackSkipped: useCallback((stepId: string, index: number) => trackEvent(MixpanelEventName.shepherdSkipped, { at_step_id: stepId, at_index: index }), [trackEvent]),
    trackCompleted: useCallback(() => trackEvent(MixpanelEventName.shepherdCompleted), [trackEvent]),
  };
};

export default useShepherdTracking;
